export default __webpack_public_path__ + "static/media/cloud.20bd7561.jpg";